import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { getOtherProperties } from "../common/Utils";
import { ProgressProps } from "./PropsType";

export default function Progress(props: ProgressProps) {
  const {
    animated,
    className,
    completeColor = "#26a69a",
    children,
    height,
    loading,
    showValue,
    striped,
    width,
    prefixCls = "bm-Progress",
    ...other
  }: any = props;
  let barColor = props.barColor;
  const styleClass = classNames(
    prefixCls,
    {
      [`${prefixCls}-striped`]: striped,
      [`${prefixCls}-animated`]: animated,
    },
    className
  );
  const [value, setValue] = useState(
    !!props.value && props.value > 0 ? props.value : 0
  );
  if (value >= 100) {
    barColor = completeColor;
  }
  const barStyle = {
    width: value + "%",
    background: barColor,
  };
  const styles = { width, height };
  const otherProps = getOtherProperties(other, ["onComplete"]);

  useEffect(() => {
    if (typeof props.value === "number") {
      setValue(props.value);
      if (props.onComplete && props.value === 100) {
        (props.onComplete as () => void)();
      }
    }
  }, [props.value]);

  return (
    <div className={styleClass} style={styles} {...otherProps}>
      {loading ? (
        <span className={`${prefixCls}-bar-infinite`} />
      ) : (
        <div className={`${prefixCls}-inner`}>
          <div className={`${prefixCls}-bar`} style={barStyle}>
            {children}
            {showValue ? (
              <span className={`${prefixCls}-text`}>{value + "%"}</span>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}
